import _ from 'lodash';

import { User } from '../types';

export const user: Partial<User> = {
  get name() {
    return _.get(window, '__user__.basicInfo.alias');
  },
  get id() {
    return _.get(window, '__user__.userId');
  },
  get userGroup() {
    return _.get(window, '__user__.userGroup');
  },
  get email() {
    return _.get(window, '__user__.basicInfo.email');
  },

  get p() {
    return _.get(window, '__user__.p');
  },
  get permissionMap() {
    return _.get(window, '__user__.permissionMap');
  },
  get applications() {
    return _.get(window, '__user__.applications');
  },
  get apps() {
    return _.get(window, '__user__.apps');
  },
  get roles() {
    return _.get(window, '__user__.roles');
  },
  get appHostMap() {
    return _.get(window, '__user__.appHostMap', {});
  },

  get basic() {
    return _.get(window, '__user__.basicInfo');
  },
  get preference() {
    return _.get(window, '__user__.preference');
  },
  get organization() {
    return _.get(window, '__user__.basicInfo.organization');
  },
  get trialEnabled() {
    return _.get(window, '__user__.trialEnabled');
  },
  get subscription() {
    return _.get(window, '__user__.subscription');
  },
  get authType() {
    return _.get(window, '__user__.authType');
  },

  set: (userInfo: User) => {
    window.__user__ = userInfo;
    Object.setPrototypeOf(user, window.__user__);

    window.__user__.p = {};
    window.__user__.permissionMap = {};
    window.__user__.accessibleAppMap = {};
    window.__user__.applications = [];
    window.__user__.roles = [];
    window.__user__.appHostMap = userInfo.appHostUrls;

    try {
      // setup p
      (userInfo.apps || []).forEach((app: any) => {
        window.__user__.p[app.appKey] = true;
      });
      (userInfo.permissions || []).forEach(permission => {
        window.__user__.permissionMap[permission] = true;
      });
      (userInfo.appGroups || []).forEach((group: any) => {
        window.__user__.p[group.appGroupKey] = true;
      });
      (userInfo.appDetails || [])
        .filter((d: any) => d.access)
        .forEach((detail: any) => {
          window.__user__.p[detail.appDetailKey] = true;
        });

      // setup accessibleAppMap
      (userInfo.accessibleApps || []).forEach((app: any) => {
        window.__user__.accessibleAppMap[app.appKey] = true;
      });

      // setup applications
      (userInfo.apps || []).forEach((app: any) => {
        window.__user__.applications.push(app.appKey);
      });

      // setup roles
      (userInfo.userRoles || []).forEach(role => {
        window.__user__.roles.push(role.userRoleName);
      });
    } catch (e) {
      // eslint-disable-next-line
      console.error(e);
    }
  },
};
